import React from 'react';
import "./Error.css";
 
const Error = (props) => {
    return (
       <div className="color-danger">
          {props.Message}
       </div>
    );
}
 
export default Error;